import { CASE_STATUSES, type CaseStatus } from "@kansai-ai-hub/types";

/**
 * 企業「案件管理」一覧のステータス絞り込みを解決する。
 * 事前承認の廃止で公開フラグ（isPublished）は撤去。可視性は status から一意に導出するため、
 * 企業は自社の全ステータス（下書き/募集中/進行中/完了/停止中）を一覧でき、status で絞り込む。
 */
export function deriveActiveFilters(statusFilter?: string): { statuses: string } {
  const allStatuses = CASE_STATUSES.join(",");
  const valid = new Set<string>(CASE_STATUSES as readonly CaseStatus[]);
  const statusVals = (statusFilter ?? "")
    .split(",")
    .filter((v) => valid.has(v));
  const statuses = statusVals.length > 0 ? statusVals.join(",") : allStatuses;
  return { statuses };
}
